import tpv from './base';

import { i18nEPG } from './epgi18n';
import { apiGetter } from '@synergycms_core/utils/api';


export default class STRIPE extends tpv {
  environment = 'stage';
  paymentIntent = null;

  /**
   *
   * @param environment
   * @param reservation
   * @param hotel
   * @param tpvPaymentStatus
   * @param setReservationPayed
   * @param showConfirmation
   * @param showErrorNotification
   */
  constructor(
    environment,
    reservation,
    hotel,
    tpvPaymentStatus,
    setReservationPayed,
    showConfirmation,
    showErrorNotification
  ) {
    super();
    this.environment = environment;
    this.paycometApi = apiGetter();

    if (
      tpvPaymentStatus === 'STRIPE:OK' &&
      reservation.get('status') === 'confirmed' &&
      reservation.getIn(['payment', 'payform_code']) === 'op'
    ) {
      //setReservationPayed(reservation, hotel.get('show_taxes'));
      showConfirmation(reservation, hotel);
    } else if (tpvPaymentStatus === 'STRIPE:ERROR') {
      showErrorNotification('ha ocurrido un error con el proceso de pago online, por favor, vuelva a intentarlo');
    }
    
  }

  /**
   *
   * @param hotel
   * @param reservation
   * @param countryCode
   * @param langCode
   * @param formId
   * @param currencyCode
   * @param showErrorNotification
   * @returns {Promise<T>}
   */
  initialize = (
    hotel,
    reservation,
    countryCode,
    langCode,
    formId,
    currencyCode,
    showErrorNotification,
    payFormCode
  ) => {

    if (
      reservation.get('status') === 'confirmed' &&
      payFormCode === 'op' &&
      reservation.getIn(['payment', 'state']) === 'pending'
    ) {
      showErrorNotification('ha ocurrido un error con el proceso de pago online, por favor, vuelva a intentarlo');
    }

    const amountPromoPaid = reservation.getIn(['payment', 'amount_promo_paid'], 0);
    let amountToPay = reservation.get('total_price_tax') - amountPromoPaid;

    return this.getStripeUrl(
      hotel.get('code'),
      amountToPay,
      reservation.get('tracking_id'),
      hotel.get('id'),
      document.URL,
      currencyCode,
      langCode,
      payFormCode
    ).then(result => {
      if (payFormCode === 'op') {
        this.queryObj = result;
      }
    });

  };


  getStripeUrl = (hotelCode, price, trackingId, hotelId, redirectUrl, currency, lang, payform) => {

    const domain = process.env.NODE_ENV != "production" ? 'https://syn2pre.booking-channel.com' : 'https://synergy.booking-channel.com';
    const url = domain + '/api/hotels/'+hotelId+'/stripe_payments';
    const data = {
      currency : currency,
      lang: lang,
      amount : price,
      id: hotelCode + '-' + trackingId,
      location: redirectUrl,
      payform_code: payform,
      only_location : payform === 'htl'
    };

    return this.query(url, 'POST', data);

  };


  /**
   *
   * @param onSubmit {function}
   * @param validForm {boolean}
   * @param inputList {Object}
   * @param resolve {function}
   * @param reject {function}
   */
  validatePayment = () => {
    window.location.replace(this.queryObj);
  };
  

}
